import { render, staticRenderFns } from "./yh_aside.vue?vue&type=template&id=a5c6d5f0&scoped=true&"
import script from "./yh_aside.vue?vue&type=script&lang=js&"
export * from "./yh_aside.vue?vue&type=script&lang=js&"
import style0 from "./yh_aside.vue?vue&type=style&index=0&id=a5c6d5f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c6d5f0",
  null
  
)

export default component.exports